/**
 * PandaCore vs open-source engines, measured with SagerNet tun-bench (201b780) on
 * macos 2026-09-19 and linux 2026-09-18.
 * Generated by scripts/pandacore-bench/generate-tunbench-results.mjs from darwin-2026-09-19-r1.json, darwin-2026-09-19-r2.json, darwin-2026-09-19-r3.json, linux-2026-09-18-ead43ef.json, linux-2026-09-18-mihomo-1.19.31.json;
 * do not edit by hand.
 */
import type { TunBenchDataset } from './pandaCoreBenchmarks'

export const tunBench: TunBenchDataset = {
  "tool": {
    "name": "tun-bench",
    "commit": "201b780"
  },
  "generatedFrom": [
    "darwin-2026-09-19-r1.json",
    "darwin-2026-09-19-r2.json",
    "darwin-2026-09-19-r3.json",
    "linux-2026-09-18-ead43ef.json",
    "linux-2026-09-18-mihomo-1.19.31.json"
  ],
  "platforms": [
    {
      "id": "macos",
      "os": "darwin",
      "arch": "arm64",
      "host": "Mac mini · Apple M1 · macOS 26.5.1",
      "measuredAt": "2026-09-19",
      "rounds": 3,
      "mtu": 4064,
      "durationSeconds": 5,
      "warmupSeconds": 1,
      "tunnelWorkers": 8,
      "loadMetric": "energy",
      "pandaCoreVersion": "1.9.2 + macOS optimizations (shipped in 1.9.3)",
      "pandaCoreBinarySha256": "9066435c6d6c5c99be33069d537c1a58be3aa838e557254260db188ff99bbe48",
      "singBoxVersion": "1.15.0-alpha.4",
      "engine2": {
        "version": "1.19.31",
        "stack": "gvisor"
      },
      "throughput": [
        {
          "id": "upload-p1",
          "direction": "upload",
          "parallel": 1,
          "bitrateGbps": 0,
          "unit": "Gbit/s",
          "higherIsBetter": true,
          "pandaCore": {
            "gbitPerSecond": 32.874,
            "cpuPercent": 97.3,
            "cpuPercentPerGbit": 2.973,
            "seconds": 5.021,
            "joulesPerGbit": 0.08902,
            "queues": 1
          },
          "singBox": {
            "gbitPerSecond": 27.294,
            "cpuPercent": 96.8,
            "cpuPercentPerGbit": 3.552,
            "seconds": 5.016,
            "joulesPerGbit": 0.11332,
            "queues": 1
          },
          "engine2": {
            "gbitPerSecond": 2.58,
            "cpuPercent": 253.8,
            "cpuPercentPerGbit": 98.237,
            "seconds": 5.014,
            "joulesPerGbit": 1.29409,
            "queues": 1
          }
        },
        {
          "id": "upload-p8",
          "direction": "upload",
          "parallel": 8,
          "bitrateGbps": 0,
          "unit": "Gbit/s",
          "higherIsBetter": true,
          "pandaCore": {
            "gbitPerSecond": 20.177,
            "cpuPercent": 95.4,
            "cpuPercentPerGbit": 4.749,
            "seconds": 5.027,
            "joulesPerGbit": 0.11445,
            "queues": 1
          },
          "singBox": {
            "gbitPerSecond": 19.429,
            "cpuPercent": 94.7,
            "cpuPercentPerGbit": 4.906,
            "seconds": 5.024,
            "joulesPerGbit": 0.1397,
            "queues": 1
          },
          "engine2": {
            "gbitPerSecond": 1.943,
            "cpuPercent": 332.2,
            "cpuPercentPerGbit": 170.11,
            "seconds": 5.018,
            "joulesPerGbit": 1.19909,
            "queues": 1
          }
        },
        {
          "id": "upload-p1-1gbps",
          "direction": "upload",
          "parallel": 1,
          "bitrateGbps": 1,
          "unit": "Gbit/s",
          "higherIsBetter": true,
          "pandaCore": {
            "gbitPerSecond": 0.993,
            "cpuPercent": 24.2,
            "cpuPercentPerGbit": 24.378,
            "seconds": 5.046,
            "joulesPerGbit": 0.0155,
            "queues": 1
          },
          "singBox": {
            "gbitPerSecond": 0.993,
            "cpuPercent": 27.9,
            "cpuPercentPerGbit": 28.11,
            "seconds": 5.046,
            "joulesPerGbit": 0.01724,
            "queues": 1
          },
          "engine2": {
            "gbitPerSecond": 0.997,
            "cpuPercent": 149.6,
            "cpuPercentPerGbit": 150.12,
            "seconds": 5.014,
            "joulesPerGbit": 2.07201,
            "queues": 1
          }
        },
        {
          "id": "download-p1",
          "direction": "download",
          "parallel": 1,
          "bitrateGbps": 0,
          "unit": "Gbit/s",
          "higherIsBetter": true,
          "pandaCore": {
            "gbitPerSecond": 29.184,
            "cpuPercent": 95.5,
            "cpuPercentPerGbit": 3.272,
            "seconds": 5.013,
            "joulesPerGbit": 0.08823,
            "queues": 1
          },
          "singBox": {
            "gbitPerSecond": 27.296,
            "cpuPercent": 96.1,
            "cpuPercentPerGbit": 3.52,
            "seconds": 5.022,
            "joulesPerGbit": 0.10199,
            "queues": 1
          },
          "engine2": {
            "gbitPerSecond": 3.008,
            "cpuPercent": 118.5,
            "cpuPercentPerGbit": 39.637,
            "seconds": 5.012,
            "joulesPerGbit": 0.94949,
            "queues": 1
          }
        },
        {
          "id": "download-p8",
          "direction": "download",
          "parallel": 8,
          "bitrateGbps": 0,
          "unit": "Gbit/s",
          "higherIsBetter": true,
          "pandaCore": {
            "gbitPerSecond": 18.118,
            "cpuPercent": 98.7,
            "cpuPercentPerGbit": 5.454,
            "seconds": 5.036,
            "joulesPerGbit": 0.09907,
            "queues": 1
          },
          "singBox": {
            "gbitPerSecond": 17.436,
            "cpuPercent": 99,
            "cpuPercentPerGbit": 5.674,
            "seconds": 5.037,
            "joulesPerGbit": 0.11184,
            "queues": 1
          },
          "engine2": {
            "gbitPerSecond": 6.084,
            "cpuPercent": 392.6,
            "cpuPercentPerGbit": 64.341,
            "seconds": 5.019,
            "joulesPerGbit": 0.73535,
            "queues": 1
          }
        },
        {
          "id": "download-p1-1gbps",
          "direction": "download",
          "parallel": 1,
          "bitrateGbps": 1,
          "unit": "Gbit/s",
          "higherIsBetter": true,
          "pandaCore": {
            "gbitPerSecond": 0.993,
            "cpuPercent": 27.6,
            "cpuPercentPerGbit": 27.813,
            "seconds": 5.047,
            "joulesPerGbit": 0.01766,
            "queues": 1
          },
          "singBox": {
            "gbitPerSecond": 0.992,
            "cpuPercent": 31,
            "cpuPercentPerGbit": 31.238,
            "seconds": 5.048,
            "joulesPerGbit": 0.01884,
            "queues": 1
          },
          "engine2": {
            "gbitPerSecond": 0.997,
            "cpuPercent": 77.5,
            "cpuPercentPerGbit": 77.732,
            "seconds": 5.018,
            "joulesPerGbit": 0.78504,
            "queues": 1
          }
        }
      ],
      "memory": {
        "id": "memory",
        "metric": "physical_footprint",
        "maxConnections": 1000,
        "connectionStep": 250,
        "payloadBytes": 64,
        "pandaCore": {
          "points": [
            {
              "connections": 0,
              "mib": 9.44
            },
            {
              "connections": 250,
              "mib": 12.5
            },
            {
              "connections": 500,
              "mib": 15.11
            },
            {
              "connections": 750,
              "mib": 17.64
            },
            {
              "connections": 1000,
              "mib": 20.24
            }
          ],
          "idleMiB": 9.44,
          "loadedMiB": 20.24,
          "slopeMiBPer100": 1.08
        },
        "singBox": {
          "points": [
            {
              "connections": 0,
              "mib": 12.42
            },
            {
              "connections": 250,
              "mib": 16.81
            },
            {
              "connections": 500,
              "mib": 18.92
            },
            {
              "connections": 750,
              "mib": 20.47
            },
            {
              "connections": 1000,
              "mib": 23.66
            }
          ],
          "idleMiB": 12.42,
          "loadedMiB": 23.66,
          "slopeMiBPer100": 1.124
        },
        "engine2": {
          "points": [
            {
              "connections": 0,
              "mib": 13.8
            },
            {
              "connections": 250,
              "mib": 35.81
            },
            {
              "connections": 500,
              "mib": 55
            },
            {
              "connections": 750,
              "mib": 73.95
            },
            {
              "connections": 1000,
              "mib": 95.11
            }
          ],
          "idleMiB": 13.8,
          "loadedMiB": 95.11,
          "slopeMiBPer100": 8.131
        }
      }
    },
    {
      "id": "linux",
      "os": "linux",
      "arch": "arm64",
      "host": "Lima VM · Debian 13 · 12 vCPU · Apple M3 Max host",
      "measuredAt": "2026-09-18",
      "rounds": 1,
      "mtu": 9000,
      "durationSeconds": 5,
      "warmupSeconds": 1,
      "tunnelWorkers": 6,
      "loadMetric": "cpu",
      "pandaCoreVersion": "1.9.0 (ead43ef)",
      "singBoxVersion": "1.15.0-alpha.4",
      "engine2": {
        "version": "1.19.31",
        "stack": "gvisor"
      },
      "throughput": [
        {
          "id": "upload-p1",
          "direction": "upload",
          "parallel": 1,
          "bitrateGbps": 0,
          "unit": "Gbit/s",
          "higherIsBetter": true,
          "pandaCore": {
            "gbitPerSecond": 77.923,
            "cpuPercent": 100,
            "cpuPercentPerGbit": 1.284,
            "seconds": 5.009,
            "queues": 1
          },
          "singBox": {
            "gbitPerSecond": 62.461,
            "cpuPercent": 100.2,
            "cpuPercentPerGbit": 1.604,
            "seconds": 5.012,
            "queues": 1
          },
          "engine2": {
            "gbitPerSecond": 5.034,
            "cpuPercent": 92.5,
            "cpuPercentPerGbit": 18.366,
            "seconds": 5.008,
            "queues": 1
          }
        },
        {
          "id": "upload-p8",
          "direction": "upload",
          "parallel": 8,
          "bitrateGbps": 0,
          "unit": "Gbit/s",
          "higherIsBetter": true,
          "pandaCore": {
            "gbitPerSecond": 194.215,
            "cpuPercent": 499,
            "cpuPercentPerGbit": 2.569,
            "seconds": 5.012,
            "queues": 1
          },
          "singBox": {
            "gbitPerSecond": 133.202,
            "cpuPercent": 498.2,
            "cpuPercentPerGbit": 3.74,
            "seconds": 5.012,
            "queues": 6
          },
          "engine2": {
            "gbitPerSecond": 19.105,
            "cpuPercent": 477.7,
            "cpuPercentPerGbit": 25.006,
            "seconds": 5.011,
            "queues": 1
          }
        },
        {
          "id": "upload-p1-1gbps",
          "direction": "upload",
          "parallel": 1,
          "bitrateGbps": 1,
          "unit": "Gbit/s",
          "higherIsBetter": true,
          "pandaCore": {
            "gbitPerSecond": 0.997,
            "cpuPercent": 11.3,
            "cpuPercentPerGbit": 11.377,
            "seconds": 5.025,
            "queues": 1
          },
          "singBox": {
            "gbitPerSecond": 0.999,
            "cpuPercent": 14.5,
            "cpuPercentPerGbit": 14.558,
            "seconds": 5.021,
            "queues": 1
          },
          "engine2": {
            "gbitPerSecond": 0.999,
            "cpuPercent": 38.7,
            "cpuPercentPerGbit": 38.787,
            "seconds": 5.008,
            "queues": 1
          }
        },
        {
          "id": "download-p1",
          "direction": "download",
          "parallel": 1,
          "bitrateGbps": 0,
          "unit": "Gbit/s",
          "higherIsBetter": true,
          "pandaCore": {
            "gbitPerSecond": 44.092,
            "cpuPercent": 100.2,
            "cpuPercentPerGbit": 2.273,
            "seconds": 5.008,
            "queues": 1
          },
          "singBox": {
            "gbitPerSecond": 42.84,
            "cpuPercent": 99.9,
            "cpuPercentPerGbit": 2.331,
            "seconds": 5.007,
            "queues": 1
          },
          "engine2": {
            "gbitPerSecond": 2.642,
            "cpuPercent": 82.6,
            "cpuPercentPerGbit": 31.266,
            "seconds": 5.012,
            "queues": 1
          }
        },
        {
          "id": "download-p8",
          "direction": "download",
          "parallel": 8,
          "bitrateGbps": 0,
          "unit": "Gbit/s",
          "higherIsBetter": true,
          "pandaCore": {
            "gbitPerSecond": 96.504,
            "cpuPercent": 499.3,
            "cpuPercentPerGbit": 5.174,
            "seconds": 5.011,
            "queues": 1
          },
          "singBox": {
            "gbitPerSecond": 106.691,
            "cpuPercent": 499.7,
            "cpuPercentPerGbit": 4.684,
            "seconds": 5.011,
            "queues": 6
          },
          "engine2": {
            "gbitPerSecond": 11.248,
            "cpuPercent": 415.1,
            "cpuPercentPerGbit": 36.904,
            "seconds": 5.011,
            "queues": 1
          }
        },
        {
          "id": "download-p1-1gbps",
          "direction": "download",
          "parallel": 1,
          "bitrateGbps": 1,
          "unit": "Gbit/s",
          "higherIsBetter": true,
          "pandaCore": {
            "gbitPerSecond": 0.998,
            "cpuPercent": 12.8,
            "cpuPercentPerGbit": 12.796,
            "seconds": 5.011,
            "queues": 1
          },
          "singBox": {
            "gbitPerSecond": 0.999,
            "cpuPercent": 14.4,
            "cpuPercentPerGbit": 14.377,
            "seconds": 5.015,
            "queues": 1
          },
          "engine2": {
            "gbitPerSecond": 0.999,
            "cpuPercent": 40.3,
            "cpuPercentPerGbit": 40.352,
            "seconds": 5.011,
            "queues": 1
          }
        }
      ],
      "memory": {
        "id": "memory",
        "metric": "rss",
        "maxConnections": 1000,
        "connectionStep": 250,
        "payloadBytes": 64,
        "pandaCore": {
          "points": [
            {
              "connections": 0,
              "mib": 31.75
            },
            {
              "connections": 250,
              "mib": 34.7
            },
            {
              "connections": 500,
              "mib": 37.06
            },
            {
              "connections": 750,
              "mib": 40.54
            },
            {
              "connections": 1000,
              "mib": 43.06
            }
          ],
          "idleMiB": 31.75,
          "loadedMiB": 43.06,
          "slopeMiBPer100": 1.131
        },
        "singBox": {
          "points": [
            {
              "connections": 0,
              "mib": 57.23
            },
            {
              "connections": 250,
              "mib": 63.91
            },
            {
              "connections": 500,
              "mib": 68.52
            },
            {
              "connections": 750,
              "mib": 72.65
            },
            {
              "connections": 1000,
              "mib": 75.26
            }
          ],
          "idleMiB": 57.23,
          "loadedMiB": 75.26,
          "slopeMiBPer100": 1.803
        },
        "engine2": {
          "points": [
            {
              "connections": 0,
              "mib": 41.63
            },
            {
              "connections": 250,
              "mib": 70.5
            },
            {
              "connections": 500,
              "mib": 86.13
            },
            {
              "connections": 750,
              "mib": 107.88
            },
            {
              "connections": 1000,
              "mib": 129.47
            }
          ],
          "idleMiB": 41.63,
          "loadedMiB": 129.47,
          "slopeMiBPer100": 8.784
        }
      }
    }
  ]
}
